import * as React from 'react';
import {Set} from 'immutable';
import {DangerousHtmlString} from "../../../lib/types";

import {Person} from "../../../contacts/value objects";
import {Category, Preferences} from "../ValueObjects";
import {TemplateComponent} from "../../../innertemplatemanager/TemplateableComponent";
import {Template} from "../../../innertemplatemanager/Template";

export interface FormProps {
	header:DangerousHtmlString
	preferences: Preferences|null
	user: Person|null
	categoryTree: Category[]
	isShown: boolean
	hide:() => void
	saveCategories: (categoryIds:Category[]) => void
}

export interface FormState {
	selectedCategories: Set<Category>
}

interface CategoryComponentProps {
	categories: Category[]
	selected: Set<Category>
	onSelectionUpdated: (newSelection: Set<Category>) => void
}

class CategoryComponent extends React.Component<CategoryComponentProps, {}> {
	render(): JSX.Element|null {
		return this.props.categories === null || this.props.categories.length == 0 ? null : (
			<ul>
				{this.props.categories.map((category:Category) => {
					const inputId = `preference-category-${category.getId()}`
					return <li key={category.getId()}>
						<input
							id={inputId}
							type="checkbox"
							checked={this.isSelected(category)}
							onChange={() => this.onCategoryToggled(category)}
						/>
						<label htmlFor={inputId}>{category.getLabel()}</label>
						<CategoryComponent onSelectionUpdated={this.props.onSelectionUpdated}
							selected={this.props.selected} categories={category.children} />
					</li>
				})}
			</ul>
		)
	}

	private isSelected(category:Category):boolean {
		return this.props.selected.has(category)
	}

	private onCategoryToggled(toggledCategory:Category) {
		const selectedCategories = this.isSelected(toggledCategory)
			? this.props.selected.delete(toggledCategory)
			: this.props.selected.add(toggledCategory)

		this.props.onSelectionUpdated(selectedCategories)
	}
}

export class Form extends React.Component<FormProps, FormState> {
	constructor(props?:FormProps, context?:any) {
		super(props, context)

		const categoryList:Category[] = Category.flattenTree(this.props.categoryTree)

		const {preferences} = this.props
		const selectedCategories = preferences == null
			? []
			: categoryList.filter((category) => preferences.isCategorySelected(category))

		this.state = { selectedCategories: Set(selectedCategories) }
	}

	render() {
		if (!this.props.isShown || this.props.user == null) {
			return null;
		}

		const close = (event:React.SyntheticEvent<{}>) => {
			this.props.hide()
			event.preventDefault()
		}

		const save = (event:React.SyntheticEvent<{}>) => {
			this.props.saveCategories(this.state.selectedCategories.toArray())
			this.props.hide()
			event.preventDefault()
		}

		return <div className="preferences-form">
			<div className="form">
				<a href="#" className="close-button" onClick={close}>Close</a>
				<div className="header" dangerouslySetInnerHTML={{__html: this.props.header}}></div>
				<div className="content">
					<CategoryComponent categories={this.props.categoryTree} selected={this.state.selectedCategories} onSelectionUpdated={(s) => this.setState({selectedCategories: s})} />
					<a className="save" href="#" onClick={save}>Save preferences</a>
					<a className="close" href="#" onClick={close}>Do this later</a>
				</div>
			</div>
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/news2/advancedSearch/preferences/PreferencesForm.tsx